@if (!hideSg()) {
  <atn-ds-select-single
    [config]="store.configSg()"
    [disabled]="store.disabledSg()"
    [error]="store.errorSg()"
    [items]="store.itemsSg()"
    [label]="store.labelSg()"
    [loading]="store.itemsLoadingSg()"
    [required]="store.requiredSg()"
    [value]="store.selectedIdSg()"
    (valueChange)="store.selectChangeHandler($event)"
    (refetch)="store.errorHandler()"
  />

  <atn-ds-custom-label-dialog />
}
